import { useFeatureFlagsContext } from '@anchorage/feature-flags';
import { useBreakpoint } from '@anchorage/hooks';
import { FEATURE_FLAGS } from 'constants/featureFlags';

/**
 * Whether the onboarding form renders in the mobile layout: the viewport is
 * below the desktop breakpoint and `ONB_MOBILE_FORM` is on.
 *
 * `undefined` means the flag has not settled yet, so no layout is chosen and
 * the URL must not change (a tablet would otherwise strip `section` before
 * LaunchDarkly answers). A desktop viewport never uses the mobile layout, so
 * it resolves to `false` right away instead of waiting for the flag, which
 * can take up to 15 seconds when LaunchDarkly cannot be reached.
 */
export const useMobileLayout = (): boolean | undefined => {
  const { isDesktop } = useBreakpoint();
  const { useIsFeatureActive } = useFeatureFlagsContext();
  const [isMobileFormActive, hasFinalValue] = useIsFeatureActive(
    FEATURE_FLAGS.ONB_MOBILE_FORM,
  );

  if (isDesktop) {
    return false;
  }
  if (!hasFinalValue) {
    return undefined;
  }
  return isMobileFormActive;
};
